import { makeVar } from "@apollo/client";
export var globalPageInfo = makeVar(undefined);
